import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { fetchApi } from '../../../utils/functions/api';
import { enqueueSnackbar } from '../../../redux/actions/appActions';
import StatusKYC from '../../../views/core/customListActions/StatusKYC';
import translation from '../../../translation/translation';

const mapDispatchToProps = (dispatch) => {
  return {
    getStatusKYC: (providerId, callbackSuccess, callbackError) => {
      if (!providerId) {
        return;
      }

      fetchApi(
        'get',
        `payers`,
        { filters: `iam_user_id|eq|${providerId}` },
        null,
        null,
        (success) => {
          if (success && success.length > 0) {
            const payerId = success[0].id;

            if (!payerId) {
              if (callbackError && typeof callbackError === 'function') {
                callbackError(
                  translation().core.list.dialogs.custom_list_actions.status_kyc.callbacks.no_payer
                );
              }
              return;
            }

            fetchApi(
              'get',
              `payers/${payerId}/kyc`,
              null,
              null,
              null,
              (success) => {
                if (callbackSuccess && typeof callbackSuccess === 'function') {
                  callbackSuccess(success);
                }
              },
              (error) => {
                if (error.response) {
                  dispatch(
                    enqueueSnackbar({
                      message:
                        error.response.data && error.response.data.detail
                          ? error.response.data.detail
                          : translation().core.list.dialogs.custom_list_actions.status_kyc.callbacks
                              .error,
                      status: error.response.status || undefined,
                      options: {
                        variant: 'error'
                      }
                    })
                  );
                } else {
                  dispatch(
                    enqueueSnackbar({
                      message:
                        translation().core.list.dialogs.custom_list_actions.status_kyc.callbacks
                          .error,
                      options: {
                        variant: 'error'
                      }
                    })
                  );
                }

                if (callbackError && typeof callbackError === 'function') {
                  callbackError(error);
                }
              }
            );
          } else {
            if (callbackError && typeof callbackError === 'function') {
              callbackError(
                translation().core.list.dialogs.custom_list_actions.status_kyc.callbacks.no_payer
              );
            }
          }
        },
        (error) => {
          if (callbackError && typeof callbackError === 'function') {
            callbackError(error);
          }
          return null;
        }
      );
    }
  };
};

export default withRouter(connect(null, mapDispatchToProps)(StatusKYC));
